const CategoryIcon = ({ fill = "var(--green)", size = "14" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none">
      <g clipPath="url(#clip0_963_5444)">
        <path
          d="M10.5 7.875C11.9497 7.875 13.125 9.05025 13.125 10.5C13.125 11.9497 11.9497 13.125 10.5 13.125C9.05025 13.125 7.875 11.9497 7.875 10.5C7.875 9.05025 9.05025 7.875 10.5 7.875ZM10.5 8.75C9.5335 8.75 8.75 9.5335 8.75 10.5C8.75 11.4665 9.5335 12.25 10.5 12.25C11.4665 12.25 12.25 11.4665 12.25 10.5C12.25 9.5335 11.4665 8.75 10.5 8.75ZM3.5 1.75C4.4665 1.75 5.25 2.5335 5.25 3.5C5.25 4.4665 4.4665 5.25 3.5 5.25C2.5335 5.25 1.75 4.4665 1.75 3.5C1.75 2.5335 2.5335 1.75 3.5 1.75ZM3.5 2.625C3.01675 2.625 2.625 3.01675 2.625 3.5C2.625 3.98325 3.01675 4.375 3.5 4.375C3.98325 4.375 4.375 3.98325 4.375 3.5C4.375 3.01675 3.98325 2.625 3.5 2.625ZM3.5 7C5.433 7 7 8.567 7 10.5C7 12.433 5.433 14 3.5 14C1.567 14 0 12.433 0 10.5C0 8.567 1.567 7 3.5 7ZM3.5 7.875C2.05025 7.875 0.875 9.05025 0.875 10.5C0.875 11.9497 2.05025 13.125 3.5 13.125C4.94975 13.125 6.125 11.9497 6.125 10.5C6.125 9.05025 4.94975 7.875 3.5 7.875ZM10.5 0C12.433 0 14 1.567 14 3.5C14 5.433 12.433 7 10.5 7C8.567 7 7 5.433 7 3.5C7 1.567 8.567 0 10.5 0ZM10.5 0.875C9.05025 0.875 7.875 2.05025 7.875 3.5C7.875 4.94975 9.05025 6.125 10.5 6.125C11.9497 6.125 13.125 4.94975 13.125 3.5C13.125 2.05025 11.9497 0.875 10.5 0.875Z"
          fill={fill}
        />
      </g>
      <defs>
        <path id="clip0_963_5444">
          <rect width="14" height="14" fill="white" />
        </path>
      </defs>
    </svg>
  );
};

export default CategoryIcon;
